import React, {useEffect} from 'react';
import classNames from 'classnames';
import {useAnimationsContext} from '../../../contexts';
import styles from './DogImage.module.scss';

interface DogImageProps extends Omit<React.HTMLProps<HTMLImageElement>, 'src' | 'alt'> {
  className?: string;
}

const tuningOffset = 500;

const DogImage = ({className, ...props}: DogImageProps) => {
  const {animationDuration, animations} = useAnimationsContext();

  useEffect(() => {
    if (animations.dog.isOpen) {
      setTimeout(animations.dog.hide, animationDuration - tuningOffset);
    }
  }, [animations.dog.isOpen]);

  return animations.dog.isOpen && (
    <img src={animations.dog.image} alt="dog" className={classNames(styles.image, className)} {...props} />
  );
};

export default DogImage;